// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2HMtk","colMin":"styles_colMin__2kX8w","colCheckbox":"styles_colCheckbox__VmSlZ"};